import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type Center } from '@avanta/shared/types/centers';
import { type AxiosResponse } from 'axios';

const CENTERS_URL = `${BASE_URL}centers`;

type CenterServiceTypes = {
  getCenter: (centerId: string) => Promise<AxiosResponse<Center>>;
};

export const CenterService: CenterServiceTypes = {
  getCenter: async centerId => service.get(`${CENTERS_URL}/${centerId}`),
};
